// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"a60f39a5","560":"c34d3ac6","778":"7d6553e3"}[chunkId] + ".chunk.js";
};